module.exports = __webpack_public_path__ + "img/Group 5120.c7046ba6.svg";